import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColumns3Wide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconColumns3Wide"><Path d="M7.33984 20H2V4H7.33984V20Z" fill="currentColor"/><Path d="M14.6602 20H9.33984V4H14.6602V20Z" fill="currentColor"/><Path d="M22 20H16.6602V4H22V20Z" fill="currentColor"/></CentralIconBase>;
});

export default IconColumns3Wide;
